import { createSlice } from '@reduxjs/toolkit';

const amendmentsSlice = createSlice({
  name: 'amendments',
  initialState: [],
  reducers: {
    setRequestAmendments: (state, { payload }) => {
      return payload;
    },
  },
});

export const { setRequestAmendments } = amendmentsSlice.actions;
export default amendmentsSlice.reducer;
